const GenerateRandom =  (max) => {
  return Math.floor(Math.random() * max) + 100
}

export  function useRandom(max = 5000) {
  return  GenerateRandom(max);
}
